export default __webpack_public_path__ + "static/media/spectra-com6.0dd93fe1.jpg";